import React from 'react'

import './Message.css'
import TextMessage from './TextMessage/TextMessage'
import ImageMessage from './ImageMessage/ImageMessage'
import TemplateMessage from './TemplateMessage/GenericTemplate/TemplateMessage'
import FileMessage from './FileMessage/FileMessage'

import { NewMessagesLine } from './NewMessagesLine'

const MessageBody = ({
  classes,
  message,
  postMessage,
  parentURL,
  showLogo,
  showReply,
  device,
  settings,
  timestamp,
  isFullScreenWidget,
  openIframe,
  openShare,
  messageBorder,
  messageMargin,
  isMobile,
  firstUnreadMessageId,
  firstUnreadMessageRef,
}) => (
  <>
    {firstUnreadMessageId &&
    message.id &&
    firstUnreadMessageId === message.id && (
      <NewMessagesLine firstUnreadMessageRef={firstUnreadMessageRef} />
    )}
    {message.type === 'text' && message.text && (
      <TextMessage
        device={device}
        text={message.text}
        showLogo={showLogo}
        settings={settings}
        timestamp={timestamp}
        showReply={showReply}
        classesNames={classes}
        openIframe={openIframe}
        isMobile={isMobile}
        postMessage={postMessage}
        message={message}
        messageBorder={messageBorder}
        messageMargin={messageMargin}
        isFullScreenWidget={isFullScreenWidget}
      />
    )}
    {message.attachments && (
      <>
        {message.attachments.map((attachment, index) => (
          <FileMessage
            key={index}
            style={classes}
            device={device}
            message={message}
            settings={settings}
            isMobile={isMobile}
            showLogo={showLogo}
            timestamp={timestamp}
            showReply={showReply}
            type={attachment.type}
            postMessage={postMessage}
            parentURL={parentURL}
            title={attachment.title}
            url={attachment.payload.url}
            isFullScreenWidget={isFullScreenWidget}
          />
        ))}
      </>
    )}
    {message.type === 'generic_template' && (
      <TemplateMessage
        style={classes}
        device={device}
        message={message}
        settings={settings}
        showLogo={showLogo}
        parentURL={parentURL}
        isMobile={isMobile}
        showReply={showReply}
        timestamp={timestamp}
        openIframe={openIframe}
        postMessage={postMessage}
        attachment={message.attachment}
        openShareScreen={openShare}
        isFullScreenWidget={isFullScreenWidget}
      />
    )}
    {message.type === 'attachment' && (
      <ImageMessage
        style={classes}
        device={device}
        message={message}
        settings={settings}
        isMobile={isMobile}
        showLogo={showLogo}
        timestamp={timestamp}
        showReply={showReply}
        postMessage={postMessage}
        parentURL={parentURL}
        url={message.imageUrl}
        isFullScreenWidget={isFullScreenWidget}
      />
    )}
  </>
)

export default MessageBody
